module.exports = __webpack_public_path__ + "img/settings.ec08a2a2.jpg";